/* eslint-disable react/display-name */
import { hiddenSelector } from '@smartsheet-dataflow/formjs';
import { EntityId } from '@smartsheet-dataflow/formjs-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { PartialBy } from '../../../utils/types';

interface WithFormJSHiddenProps {
  hidden: boolean;
}

export const withFormJSHidden =
  <P extends EntityId & WithFormJSHiddenProps>(
    Component: React.ComponentType<P>
  ) =>
  (props: PartialBy<P, 'hidden'>) => {
    const hidden = useSelector(hiddenSelector(props.id));
    return <Component {...(props as P)} hidden={hidden} />;
  };
